import type { Meta, StoryObj } from "@storybook/react";

import type { RegisterButtonProps } from "@/ui/components/groupClasses/RegisterButton";
import RegisterButton from "@/ui/components/groupClasses/RegisterButton";
import type { ButtonSize } from "@/ui/core/buttons/Button";

const mockPatientName = "Olivia";

const ButtonSizeValues: Record<ButtonSize, ButtonSize> = {
  normal: "normal",
  small: "small",
};

const StoryMeta: Meta<RegisterButtonProps> = {
  title: "Components/Group Classes/Register Button",
  component: RegisterButton,
  argTypes: {
    accessibilityLabel: { control: "text" },
    forWhom: { control: "text" },
    isAppUserSupport: { control: "boolean" },
    isFullWidth: { control: "boolean" },
    isLoading: { control: "boolean" },
    isOnPressDisabled: { control: "boolean" },
    isRegistered: { control: "boolean" },
    isSensitive: { control: "boolean" },
    size: { control: "select", options: Object.values(ButtonSizeValues) },
    testID: { control: "text" },
  },
  args: {
    accessibilityLabel: "Register",
    size: "normal",
    testID: "storybook",
  },
};

type Story = StoryObj<RegisterButtonProps>;

const Primary: Story = {};

const ForPatient: Story = {
  args: {
    forWhom: mockPatientName,
  },
};

const Registered: Story = {
  args: {
    isRegistered: true,
  },
};

const RegisteredProxyAndSensitive: Story = {
  args: {
    forWhom: mockPatientName,
    isAppUserSupport: true,
    isRegistered: true,
    isSensitive: true,
  },
};

export { ForPatient, Primary, Registered, RegisteredProxyAndSensitive };
export default StoryMeta;
